export default __webpack_public_path__ + "static/media/delete.0dd71e62.svg";